import { OrgDeviceAssignmentComponent } from 'components/org-device-assignment/org-device-assignment.component';
import { SourceSelectionComponent } from 'components/source-selection/source-selection.component';
import { AdminComponent } from "./admin/admin.component";
import { BatteryStrings } from './battery-strings/battery-strings';
import { AnalyzeSettingsComponent } from './analyze/analyze-settings/analyze-settings.component';
import { AnalyzeComponent } from './analyze/analyze.component';
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { EdgeDeviceDashboardComponent } from './edge-device-dashboard/edge-device-dashboard.component';
import { EdgeDeviceSelectComponent } from './edge-device-select/edge-device-select.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ItemSelectorComponent } from './item-selector/item-selector.component';
import { LanguageSelectorComponent } from "./language-selector/language-selector.component";
import { LocaleSelectionComponent } from './locale-selection/locale-selection.component';
import { LoginComponent } from "./login/login.component";
import { LogoComponent } from "./logo/logo.component";
import { OrganizationNameComponent } from './organization-name/organization-name.component';
import { PasswordPolicyComponent } from './password-policy/password-policy.component';
import { QuickSightComponents } from './quicksight/quicksight';
import { ReportsComponent } from './reports/reports.component';
import { TestComponent } from './test/test.component';
import { UserReportsComponent } from './user-reports/user-reports.component';
import { UserComponent } from './user/user.component';

export const Components = [
    AdminComponent,
    DashboardComponent,
    AnalyzeComponent,
    AnalyzeSettingsComponent,
    LanguageSelectorComponent,
    LoginComponent,
    LogoComponent,
    SourceSelectionComponent,
    ChangePasswordComponent,
    ForgotPasswordComponent,
    UserComponent,
    PasswordPolicyComponent,
    LocaleSelectionComponent, 
    TestComponent,
    OrganizationNameComponent,
    ReportsComponent,
    ...QuickSightComponents,
    UserReportsComponent,
    ItemSelectorComponent,
    EdgeDeviceSelectComponent,
    EdgeDeviceDashboardComponent,
    BatteryStrings,
    OrgDeviceAssignmentComponent
]